import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
@Directive({
    selector: '[fiLongPressMobile]',
    standalone: false,
})
export class FiLongPressMobileDirective {
    @Input() timerValue: number = 500;
    @Output() onLongPress: EventEmitter<MouseEvent> = new EventEmitter();

    private timer: NodeJS.Timeout;

    @HostListener('touchstart', ['$event'])
    onTouchStart() {
        this.timer = setTimeout(() => {
            this.timer = null;
            this.onLongPress.emit();
        }, this.timerValue);
    }

    @HostListener('touchmove', ['$event'])
    onTouchMove() {
        clearTimeout(this.timer);
    }

    @HostListener('touchend', ['$event'])
    onTouchEnd() {
        clearTimeout(this.timer);
    }
}
